<template>
  <div id="addCalendario" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo catalogoTitle">Alta de Calendario</v-row>
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="estructura"
            id="estructura"
            v-model="enterprise"
            @change="obtenerAreasSucursales()"
          >
            <option disabled value="0">Selecciona empresa</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Nombre</v-col>
        <v-col cols="12" sm="4" class="py-2 com">
          <input
            type="text"
            id="nombre"
            name="nombre"
            maxlength="30"
            class="inputs px-2"
            placeholder="Obligatorio"
            autocomplete="false"
            v-model="calendar"
            required
            @keypress="alfaNumerico($event)"
            style="
              width: 90% !important;
              margin-left: 0;
              padding-left: 3% !important;
            "
          />
        </v-col>

        <v-col cols="12" sm="8" class="py-2">Descripción</v-col>
        <v-col cols="12" sm="4" class="py-2">
          <textarea
            id="description"
            placeholder="Escriba un dirección"
            v-model="description"
            @keypress="alfaNumerico($event)"
          ></textarea>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Lunes</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="lunes" id="lunes" v-model="lunes">
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Martes</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="lunes" id="lunes" v-model="martes">
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Miercoles</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="lunes" id="lunes" v-model="miercoles">
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>

        <v-col cols="12" sm="8" class="py-2">Jueves</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="lunes" id="lunes" v-model="jueves">
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Viernes</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="lunes" id="lunes" v-model="viernes">
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>

        <v-col cols="12" sm="8" class="py-2">Sábado</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="lunes" id="lunes" v-model="sabado">
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2 selectGris">Domingo</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="lunes" id="lunes" v-model="domingo">
            <option selected disabled value="0">Selecciona Tiempo</option>
            <option
              v-for="tiempo in tiempos"
              :key="tiempo.id"
              v-bind:value="tiempo.id"
            >
              {{ tiempo.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Aplicar a</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="empresa"
            id="empresa"
            v-model="aplicar"
            @change="condicion()"
          >
            <option disabled selected value="0">
              Seleccione lugar de aplicación
            </option>
            <option value="1">Áreas</option>
            <option value="2">Sucursales</option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2" v-if="aplicar == 2"
          >Catálogo de Sucursales</v-col
        >
        <v-col cols="12" sm="4" class="py-2" v-if="aplicar == 2">
          <multiselect
            v-model="sucursalesSeleccionadas"
            track-by="id"
            @input="sucursalAuxiliar"
            label="nombreSucursal"
            placeholder="Seleccione sucursal(es)"
            tag-placeholder="Agregar sucursal"
            selectLabel="Enter para agregar"
            deselectLabel="Enter para eliminar"
            selectedLabel="Seleccionado"
            :multiple="true"
            :options="branches"
            class="inputs"
            style="width: 170px !important"
          >
            <span slot="noResult"
              >No se encontraron elementos con la búsqueda</span
            >
            <span slot="noOptions">No existen elementos</span>
          </multiselect>
        </v-col>
        <v-col cols="12" sm="8" class="py-2" v-if="aplicar == 1"
          >Catálogo de Áreas</v-col
        >
        <v-col cols="12" sm="4" class="py-2" v-if="aplicar == 1">
          <multiselect
            v-model="areasSeleccionadas"
            trackBy="id"
            label="nombreArea"
            @input="areasAuxiliares"
            placeholder="Seleccione área(s)"
            tag-placeholder="Agregar área"
            selectLabel="Enter para agregar"
            deselectLabel="Enter para eliminar"
            selectedLabel="Seleccionado"
            :multiple="true"
            :options="areas"
            class="inputs"
            style="width: 170px !important"
          >
            <span slot="noResult"
              >No se encontraron elementos con la búsqueda</span
            >
            <span slot="noOptions">No existen elementos</span>
          </multiselect>
        </v-col>
        <v-col>
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>
    <!--Aceptación de acciones-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Aviso</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 style="text-align: center">{{ respuesta }}</h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="
              advice = false;
              id = '';
            "
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="error" width="380">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Error</span>
        </v-card-title>
        <v-card-text>
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Calendario</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            El calendario fue guardado con éxito
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="regresar()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "13-N",
      search: "",
      show: false,
      expiration: false,
      dialog: false,
      errors: [],
      enterprise: localStorage.empresaIdGlobal,
      enterprises: [],
      respuesta: "",
      advice: false,
      error: false,
      confirmation: false,
      calendar: "",
      lunes: 0,
      martes: 0,
      miercoles: 0,
      jueves: 0,
      viernes: 0,
      sabado: 0,
      domingo: 0,
      description: "",
      aplicar: 0,
      sucursal: 0,
      areaTrue: false,
      branchTrue: false,
      areas: [],
      areasSeleccionadas: [],
      areasAux: [],
      branches: [],
      sucursalesSeleccionadas: [],
      sucursales: [],
      tiempos: [
        { id: 1, name: "Tiempo completo" },
        { id: 3, name: "Medio Tiempo" },
        { id: 2, name: "Descanso" },
      ],
    };
  },
  methods: {
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.show = false;
          this.enterprises = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    nombre() {
      localStorage.stepn = this.stepn;
    },
    regresar() {
      this.confirmation = false;
      this.$router.push("/calendar");
    },
    condicion() {
      if (this.aplicar == 1) {
        this.branchTrue = false;
        this.areaTrue = true;
      }
      if (this.aplicar == 2) {
        this.areaTrue = false;
        this.branchTrue = true;
      }
    },
    validacion: function () {
      this.errors = [];
      console.log("areas");
      console.log(this.areasSeleccionadas);
      console.log("sucursales");
      console.log(this.sucursalesSeleccionadas);
      if (this.enterprise == " " || this.calendar == 0) {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.calendar == " " || this.calendar == "") {
        this.errors.push("Se debe especificar nombre del calendario.");
      }
      if (this.description == " " || this.description == "") {
        this.errors.push("Se debe especificar la descripcion del calendario.");
      }
      if (this.lunes == 0) {
        this.errors.push("Se debe seleccionar el horario el día lunes.");
      }
      if (this.martes == 0) {
        this.errors.push("Se debe seleccionar el horario el día martes.");
      }
      if (this.miercoles == 0) {
        this.errors.push("Se debe seleccionar el horario el día miercoles.");
      }
      if (this.jueves == 0) {
        this.errors.push("Se debe seleccionar el horario el día jueves.");
      }
      if (this.viernes == 0) {
        this.errors.push("Se debe seleccionar el horario el día viernes.");
      }
      if (this.sabado == 0) {
        this.errors.push("Se debe seleccionar el horario el día sabado.");
      }
      if (this.domingo == 0) {
        this.errors.push("Se debe seleccionar el horario el día domingo.");
      }
      if (this.aplicar == 0) {
        this.errors.push("Se debe especificar el lugar de asignación.");
      }
      if (this.aplicar == 1 && this.areasSeleccionadas.length == 0) {
        this.errors.push("Se debe especificar el área.");
      }
      if (this.aplicar == 2 && this.sucursalesSeleccionadas.length == 0) {
        this.errors.push("Se debe especificar la sucursal.");
      }
      if (this.errors.length == 0) {
        this.respuesta = "¿Esta seguro de almacenar el Calendario?";
        return (this.advice = true);
      } else {
        this.respuesta = "Por favor corrige el(los) siguiente(s) error(es):";
        this.error = true;
      }
    },
    guardar() {
      this.advice = false;
      this.show = true;
      axios
        .post(
          Server + "/calendarios",
          {
            EmpresaId: this.enterprise,
            Nombre: this.calendar,
            Descripcion: this.description,
            LunesCatalogoId: parseInt(this.lunes),
            MartesCatalogoId: parseInt(this.martes),
            MiercolesCatalogoId: parseInt(this.miercoles),
            ViernesCatalogoId: parseInt(this.jueves),
            JuevesCatalogoId: parseInt(this.viernes),
            SabadoCatalogoId: parseInt(this.sabado),
            DomingoCatalogoId: parseInt(this.domingo),
            Sucursales: this.sucursales,
            Areas: this.areasAux,
          },
          {
            headers: {
              Authorization: localStorage.token,
            },
          }
        )
        .then((response) => {
          this.enterprise = 0;
          this.calendar = "";
          this.description = "";
          this.lunes = "";
          this.martes = "";
          this.miercoles = "";
          this.jueves = "";
          this.viernes = "";
          this.sabado = "";
          this.domingo = "";
          this.areasAux = [];
          this.areasSeleccionadas = [];
          this.sucursales = [];
          this.sucursalesSeleccionadas = [];
          this.respuesta = "El calendario fue guardado con éxito";
          this.show = false;
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          if (e.response.status == 401) {
            this.expiration = true;
          } else {
            this.enterprise = 0;
            this.calendar = "";
            this.description = "";
            this.lunes = "";
            this.martes = "";
            this.miercoles = "";
            this.jueves = "";
            this.viernes = "";
            this.sabado = "";
            this.domingo = "";
            this.areasAux = [];
            this.areasSeleccionadas = [];
            this.sucursales = [];
            this.sucursalesSeleccionadas = [];
            this.respuesta = "El calendario no fue almacenado con éxito";
            this.confirmation = true;
          }
        });
    },
    obtenerAreasSucursales() {
      this.area = 0;
      this.sucursal = 0;
      this.areaTrue = false;
      this.branchTrue = false;
      this.aplicar = 0;
      this.branches = [];
      this.areasSeleccionadas = [];
      this.sucursalesSeleccionadas = [];
      this.show = true;
      axios
        .get(Server + "/sucursales/por-empresa/" + this.enterprise)
        .then((response) => {
          response.data.forEach((element) => {
            if (element.calendarioId == null) {
              this.branches.push(element);
            }
          });
          this.show = false;
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
      this.areas = [];
      this.show = true;
      axios
        .get(Server + "/areas")
        .then((response) => {
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (
              value.empresaId == this.enterprise &&
              value.calendarioId == null
            ) {
              this.areas.push({
                id: value.id,
                nombreArea: value.nombreArea,
                nombreCorto: value.nombreAreaCorto,
                empresa: value.empresaId,
                nombreEmpresa: value.empresa,
                nivelJerarquico: value.nivelJerarquico,
              });
            }
          });
          this.show = false;
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
    },
    aux() {
      this.advice = false;
      this.lunes = 0;
      this.martes = 0;
      this.miercoles = 0;
      this.jueves = 0;
      this.sabado = 0;
      this.domingo = 0;
      this.description = "";
      this.calendar = "";
    },
    cancelar() {
      this.lunes = 0;
      this.martes = 0;
      this.miercoles = 0;
      this.jueves = 0;
      this.sabado = 0;
      this.domingo = 0;
      this.description = "";
      this.calendar = "";
      this.$router.push("/calendars");
    },
    areasAuxiliares() {
      this.areasAux = [];
      this.areasSeleccionadas.forEach((area) => this.areasAux.push(area.id));
      //areasAux es el que se pasa a la api
      console.log(this.areasAux);
    },
    sucursalAuxiliar() {
      this.sucursales = [];
      this.sucursalesSeleccionadas.forEach((suc) =>
        this.sucursales.push(suc.id)
      );
      //sucursales es el que se pasa a la api
      console.log(this.sucursales);
    },
  },
  created() {
    this.nombre();
    this.listar();
  },
};
</script>
<style>
ul {
  list-style-type: none !important;
  display: inline-block;
}
li.multiselect_element {
  list-style-type: none !important;
}
ul.multiselect__element,
ol.multiselect__option.multiselect__option--highlight {
  text-decoration: none;
}
.v-application ol,
.v-application ul {
  padding-left: 0px !important;
  text-decoration: none !important;
}
.multiselect__option.multiselect__option--highlight {
  background: rgb(250, 181, 52) !important;
}
.multiselect__tag {
  background: rgba(253, 175, 29, 0.856) !important;
} /*
.multiselect__option--highlight:after{
  
  background: rgba(236, 154, 0, 0.856) !important;
}*/
</style>